import $ from 'jquery'
export const icitTabs = function(tabsNavi) {

  let tabsHeader = null;
  let tabsContainer = null;

  const init = function(tabsNavi) {
    tabsHeader = tabsNavi;
    
    const tabsContainerAttr = tabsHeader.attr('data-tabs-container');
    if ( tabsContainerAttr.length <= 0 )
    {
      return;
    }
    
    tabsContainer = $(tabsContainerAttr);
    if ( tabsHeader.length <= 0 || tabsContainer.length <= 0 )
    {
      return;
    }

    initClicks();
  }

  const initClicks = function() {
    tabsHeader.on('click', 'a', naviClicked);
  }

  const naviClicked = function(e) {
    e.preventDefault();
    const item = $(this);
    if ( item.hasClass('tab-active') )
    {
      return;
    }

    const tabId = item.attr('href');
    showTab(tabId);
    
  }

  const showTab = function(tabId) {
    tabsHeader.find('a[href="' + tabId + '"]').addClass('tab-active');
    tabsHeader.find('a:not([href="' + tabId + '"])').removeClass('tab-active');

    tabsContainer.find(tabId).prependTo(tabsContainer);

    tabsContainer.find('> div').addClass('processing');
    tabsContainer.find('> div:not('+ tabId +')').stop().removeClass('tab-active').slideUp();
    tabsContainer.find('> div'+ tabId +'').stop().addClass('tab-active').hide().slideDown();
  }

  init(tabsNavi);
  // tabs-header
}